import { IDistrictViewModel } from 'viewModels';
import { IDistrictInputModel, IOrderedWithPaginationInputModel } from 'inputModels';
import qs from 'qs';
import api from '../services/api/axios';

const getDistrictsByUfCode = (ufCode: number) => {
  return new Promise<IDistrictViewModel[]>((resolve, reject) => {
    api
      .get(`district/get-districts-by-state/${ufCode}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getDistrictById = (uuid: string) => {
  return new Promise<IDistrictViewModel>((resolve, reject) => {
    api
      .get(`district/get-districts-by-id/${uuid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const addDistrict = async (input: IDistrictInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`district/add-district`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const getDistrictSelectByUser = (input: IOrderedWithPaginationInputModel) => {
  return new Promise<IDistrictViewModel[]>((resolve, reject) => {
    api
      .get(`district/get-selected-by-user`, {
        params: input,
        paramsSerializer: (params) => qs.stringify(params),
      })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const getAllDistricts = (input: IOrderedWithPaginationInputModel) => {
  return new Promise<IDistrictViewModel[]>((resolve, reject) => {
    api
      .get(`district/get-all`, {
        params: input,
        paramsSerializer: (params) => qs.stringify(params),
      })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

export const DistrictController = {
  addDistrict,
  getDistrictsByUfCode,
  getDistrictById,
  getDistrictSelectByUser,
  getAllDistricts,
};
